
//import '../src/WscWebGL/includes/style.css';
import { useEffect, useState, useRef } from 'react';
import './includes/style.min.css';

//<div>Valami cucc</div>
//<img src={backgroundUrl} style={{width: 500 + 'px'}}/>

const storageStart = "https://firebasestorage.googleapis.com/v0/b/walterscube-b3767.appspot.com/o/";
const storageEnd = "?alt=media";
const templateDirWebGL = "TemplateData/";
const buildDirWebGL = "Build/";

function GetTemplateImageUrlWebGL(gameFolder, imageName)
{
    return storageStart + encodeURIComponent(gameFolder + templateDirWebGL + imageName) + storageEnd;
}

function GetBuildFileUrlWebGL(gameFolder, fileName){
	
	return storageStart + encodeURIComponent(gameFolder + buildDirWebGL + fileName) + storageEnd;
}

function GetStoragePublicUrl(path)
{
    return storageStart + encodeURIComponent(path) + storageEnd;
}


//export function WscWebGL(wsc_webgl_folder, wsc_webgl_data, wsc_webgl_code, wsc_webgl_framework, wsc_webgl_loader, exhibitionId, backgroundImg)
export function WscWebGL(webGLAppsData, exhibition, webGLSettings)
{
    const sendGaEvent = (arg1, arg2, arg3) =>
    {
        console.log('log event');
        console.log(arg3);
    }
    
    const mockPlay = () =>
    {
        //console.log('mock play');
    }
    
    const setPlayImage = (actualImg, imgUrl) =>
    {
        //console.log(imgUrl);
        //console.log('dsfdsfsd');
        actualImg.src = imgUrl;
    }

    const fullScreenClick = (actualGameId) =>
    {
        //console.log(actualGameId);
        if(unityLoader !== null)
        {
            unityLoader.SetFullscreen(1);
        }
    }

    const fixEventParam = (str) =>
    {
        return str.replaceAll(/\s\s+/g, ' ');
    }

    const query = new URLSearchParams(window.location.search);

    var embed = webGLSettings.embed;
    var notExhibition = webGLSettings.notExhibition;
    var editor = webGLSettings.editor;
    var editorDev = false; //TODO
    var editorBeta = false; //TODO
    var mobileWebgl = webGLSettings.mobileWebgl;
    var dev = webGLSettings.dev;
    
    var domain = webGLAppsData.Domain;
    var openTitleText = webGLAppsData.FooterOpenText;

    var exhibitionId = exhibition.exhibitionId;
    var exhibitionTitle = exhibition.exhibitionTitle;
    var deepLink = exhibition.deepLink;
    var artists = exhibition.artists;
    var curator = exhibition.curator;
    var galleryName = exhibition.galleryName;


    var autorun = false;
    if(webGLSettings.autoPlay)
    {
        var autorun = true;
    }

    var isQpAutoPlay = query.get('AutoPlay');
    if(isQpAutoPlay == '1')
    {
        autorun = true;
    }

    var wsc_webgl_folder;
    var wsc_webgl_data;
    var wsc_webgl_code;
    var wsc_webgl_framework;
    var wsc_webgl_loader;

    if(editor)
    {
        //TODO dev meg beta nincs miplementalva
        wsc_webgl_folder = webGLAppsData.WebGLApplications.WaltersCubeModularEditor.Folder;
        wsc_webgl_data = webGLAppsData.WebGLApplications.WaltersCubeModularEditor.DataFile;
        wsc_webgl_code = webGLAppsData.WebGLApplications.WaltersCubeModularEditor.CodeFile;
        wsc_webgl_framework = webGLAppsData.WebGLApplications.WaltersCubeModularEditor.FrameworkFile;
        wsc_webgl_loader = webGLAppsData.WebGLApplications.WaltersCubeModularEditor.LoaderFile;
    }
    else
    {
        var isQpDev = query.get('dev');
        var isQpAlpha = query.get('alpha');
        var isQpBeta = query.get('beta');
        if(isQpDev == '1')
        {
            wsc_webgl_folder = webGLAppsData.WebGLApplications.WaltersCubeWebGLDev.Folder;
            wsc_webgl_data = webGLAppsData.WebGLApplications.WaltersCubeWebGLDev.DataFile;
            wsc_webgl_code = webGLAppsData.WebGLApplications.WaltersCubeWebGLDev.CodeFile;
            wsc_webgl_framework = webGLAppsData.WebGLApplications.WaltersCubeWebGLDev.FrameworkFile;
            wsc_webgl_loader = webGLAppsData.WebGLApplications.WaltersCubeWebGLDev.LoaderFile;
        }
        else if(isQpAlpha == '1')
        {
            wsc_webgl_folder = webGLAppsData.WebGLApplications.WaltersCubeWebGLAlpha.Folder;
            wsc_webgl_data = webGLAppsData.WebGLApplications.WaltersCubeWebGLAlpha.DataFile;
            wsc_webgl_code = webGLAppsData.WebGLApplications.WaltersCubeWebGLAlpha.CodeFile;
            wsc_webgl_framework = webGLAppsData.WebGLApplications.WaltersCubeWebGLAlpha.FrameworkFile;
            wsc_webgl_loader = webGLAppsData.WebGLApplications.WaltersCubeWebGLAlpha.LoaderFile;
        }
        else if(isQpBeta == '1')
        {
            wsc_webgl_folder = webGLAppsData.WebGLApplications.WaltersCubeWebGLBeta.Folder;
            wsc_webgl_data = webGLAppsData.WebGLApplications.WaltersCubeWebGLBeta.DataFile;
            wsc_webgl_code = webGLAppsData.WebGLApplications.WaltersCubeWebGLBeta.CodeFile;
            wsc_webgl_framework = webGLAppsData.WebGLApplications.WaltersCubeWebGLBeta.FrameworkFile;
            wsc_webgl_loader = webGLAppsData.WebGLApplications.WaltersCubeWebGLBeta.LoaderFile;
        }
        else
        {
            wsc_webgl_folder = webGLAppsData.WebGLApplications.WaltersCubeWebGL.Folder;
            wsc_webgl_data = webGLAppsData.WebGLApplications.WaltersCubeWebGL.DataFile;
            wsc_webgl_code = webGLAppsData.WebGLApplications.WaltersCubeWebGL.CodeFile;
            wsc_webgl_framework = webGLAppsData.WebGLApplications.WaltersCubeWebGL.FrameworkFile;
            wsc_webgl_loader = webGLAppsData.WebGLApplications.WaltersCubeWebGL.LoaderFile;
        }
    }
    

    var backgroundColor = 'black'
    var ratioWidth = 16;
    var ratioHeight = 9;
    var aspectRatio = (ratioHeight / ratioWidth) * 100.0;
    var gameBorder = 'none';//'3px solid black'
    var gameId = 'abc123';
    //var backgroundUrl = "https://firebasestorage.googleapis.com/v0/b/walterscube-b3767.appspot.com/o/WebGLApplications%2FWaltersCubeWebGL%2Fv1_160%2FTemplateData%2Fbackground.png?alt=media";
    


    var dataUrl = GetBuildFileUrlWebGL(wsc_webgl_folder, wsc_webgl_data);
	var codeUrl = GetBuildFileUrlWebGL(wsc_webgl_folder, wsc_webgl_code);
	var frameworkUrl = GetBuildFileUrlWebGL(wsc_webgl_folder, wsc_webgl_framework);
    var loaderUrl = GetBuildFileUrlWebGL(wsc_webgl_folder, wsc_webgl_loader);
    var game = 'WaltersCubeWebGL';

    //var logoImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, "logo.png");

    var playImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.PlayImg);
    var playHoverImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.PlayHoverImg);
    var playAppImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.PlayAppImg);
	var fullScreenImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.FullScreenImg);
	var spinnerImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.SpinnerImg);

    var wscLogoImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.LogoImg); //TODO wsc home icon
    var wscLogoImgSmall = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.LogoSmallImg); //TODO small es wsc home icon
    var wscCoverLogoImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.CoverLogoImg);

    var isMobile = false; //TODO reactos valami ide

    //Todo queryStringbol
    var hideTitle = false;
    var hideArtists = false;
    var hideCurator = false;
    var hideGalleryName = false;
    var disableEmbedGalleryName = false;

    var titleText = '';

    if(!hideTitle)
    {
        titleText = "<div class=\"embed-ellipsis\" title=\"" + exhibitionTitle + "\">" + exhibitionTitle + "</div>";
    }

    if(artists != "" && !hideArtists)
    {
        titleText += "<div class=\"embed-ellipsis\" title=\"" + "Works by "  + artists + "\">" + "Works by " + artists + "</div>";
    }
    
    if(curator != "" && !hideCurator)
	{
		titleText += "<div class=\"embed-ellipsis\" title=\"" + "Curated by " + curator + "\">" + "Curated by " + curator + "</div>";
	}

    if(galleryName != "" && !hideGalleryName && !disableEmbedGalleryName)
	{
		titleText += "<div class=\"embed-ellipsis\" title=\"" + "@ " + galleryName + "\">" + "@ " + galleryName + "</div>";
	}

    window.Exhibition_ID = exhibition.exhibitionId;
    window.isModularFirebase = true;

    //var hideEmbed = false;

    var backgroundImg = null;

    if(notExhibition == false && editor == false)
    {
        if(exhibition.backgroundImg)
        {
            backgroundImg = exhibition.backgroundImg;
        }
        else
        {
            backgroundImg = GetStoragePublicUrl('HighResExhibitionIcons/H' + exhibition.exhibitionId + '.jpg');
        }
    }

    if(!backgroundImg)
    {
        backgroundImg = GetTemplateImageUrlWebGL(wsc_webgl_folder, webGLAppsData.TemplateFiles.BackgroundImg);
    }

    const SubscribeMouseLock = () =>
    {
        document.addEventListener('pointerlockchange', function()
	    {
		    var canvas = document.querySelector('canvas');
            
            if(document.pointerLockElement === canvas ||
			document.mozPointerLockElement === canvas ||
			document.webkitPointerLockElement === canvas)
			{
				var gameFooter = document.getElementById('game-footer-wscwebgl' + gameId);
			    if(gameFooter)
			    {
			        //gameFooter.style.display = \"none\";
			    }
		    }
		    else
		    {
		    	var gameFooter = document.getElementById('game-footer-wscwebgl' + gameId);
		    	if(gameFooter)
		    	{
		    	    gameFooter.style.display = 'inherit';
		    	}
		    }
		
	    }, false);
	}

    const SwitchToLoading = async () =>
    {
        document.getElementById('autorun-wscwebgl' + gameId).style.display = 'none';
		document.getElementById('bgBar-wscwebgl' + gameId).style.display = 'inherit';
		document.getElementById('progressBar-wscwebgl' + gameId).style.display = 'inherit';
		document.getElementById('loadingInfo-wscwebgl' + gameId).style.display = 'inherit';

        var backgroundCover = document.getElementById('backgroundCover' + gameId);

        if(backgroundCover)
		{
			backgroundCover.style.display = 'none';
		}

        if(dev && editor)
        {
            var bgImage = document.getElementById('background-wscwebgl' + gameId);
			if(bgImage)
			{
				bgImage.style.width = '100%';
				bgImage.style.height = '100%';
				bgImage.style.top = '0';
				bgImage.style.left = '0';
			}
			
			var gameHeader = document.getElementById('game-header-wscwebgl' + gameId);
			if(gameHeader)
			{
				gameHeader.style.display = 'none';
			}
        }

        var coverLogo = document.getElementById('logoCover-wscwebgl' + gameId);
		if(coverLogo !== undefined && coverLogo.style !== undefined){
			coverLogo.style.display = 'inherit';
		}
		
							
		var spinner = document.getElementById('spinner-wscwebgl' + gameId);
		if(spinner)
		{
			if(spinner !== undefined && spinner.style !== undefined){
				spinner.style.display = 'inherit';
			}
		}
        
        await waitUntil(() => isLoadedUnityLoader.current == true);
    }

    const waitUntil = (conditionFunction) =>
    {
        const poll = resolve => {
          if(conditionFunction()) resolve();
          else setTimeout(_ => poll(resolve), 400);
        }
        
        return new Promise(poll);
    }

    //const waitUntil = (condition, checkInterval = 100) =>
    //{
    //    return new Promise(resolve => {
    //        let interval = setInterval(() => {
    //            if (!condition()) return;
    //            clearInterval(interval);
    //            resolve();
    //        }, checkInterval)
    //    })
    //}

    var spinner;
    var coverLogo;
    var unityLoader = null;
    var jsonData = {
        'dataUrl': dataUrl,
		'frameworkUrl': frameworkUrl,
		'codeUrl': codeUrl,
		'streamingAssetsUrl': 'StreamingAssets',
		'companyName': 'WaltersCube',
		'productName': game,
		'productVersion': '1.3.13'
    }

    const OnPlayClick = async () =>
    {
        await SwitchToLoading();
        unityLoader = await window.createUnityInstance(getCanvasElement(), jsonData,
            (progress) => {
                UnityProgress2020(unityLoader, progress);
            }
        );
    }

    const getCanvasElement = () =>
    {
        var canvasWrapperElement = document.getElementById(gameId);
		
		var node = document.createElement('canvas');
		node.setAttribute('id', 'unity-canvas');
		
		var canvasElement = canvasWrapperElement.appendChild(node);
		
		return canvasElement;
    }

    const SetMessage = (message) =>
    {
        //this.message = message;
		document.getElementById('loadingInfo-wscwebgl' + gameId).innerHTML = message;
    }
    
    const Clear = (message) =>
    {
        var loadingBox = document.getElementById('loadingBox-wscwebgl' + gameId);
		if(loadingBox !== undefined && loadingBox.style !== undefined){
			loadingBox.style.display = 'none';
		}
		
		var background = document.getElementById('background-wscwebgl' + gameId);
		if(background !== undefined && background.style !== undefined){
			//background.style.display = \"none\";
		}
    }

    const UnityProgress2020 = (gameObject, progress) =>
    {
        //this.message = '';

        //this.SetMessage = function (message) {
		//	//this.message = message;
		//	document.getElementById('loadingInfo-wscwebgl' + gameId).innerHTML = this.message;
		//}

        //this.Clear = function() {
		//	var loadingBox = document.getElementById('loadingBox-wscwebgl' + gameId);
		//	if(loadingBox !== undefined && loadingBox.style !== undefined){
		//		loadingBox.style.display = 'none';
		//	}
		//	
		//	var background = document.getElementById('background-wscwebgl' + gameId);
		//	if(background !== undefined && background.style !== undefined){
		//		//background.style.display = \"none\";
		//	}
		//}

        if(dev)
        {
            if(editor)
            {
                if(progress == 0)
				{
					//this.SetMessage('Initializing...');
                    SetMessage('Initializing...');	
				} else if(progress > 0 && progress <= 1)
				{
					var progressMaxWidth = document.getElementById('progressBarWscContainerEditor' + gameId).offsetWidth
					
					var length = ((progressMaxWidth / 4) * Math.min(progress, 1)).toString();
					var bar = document.getElementById('progressBar-wscwebgl' + gameId)
					bar.style.width = length + 'px';
					var p = (progress * 100) | 0;
					//this.SetMessage('');
                    SetMessage('');
				}
            }
            else if (notExhibition == false)
            {
                if(progress == 0)
                {
				    //this.SetMessage('Initializing...');
                    SetMessage('Initializing...');
				} else if(progress > 0 && progress <= 1){
					var canvasWidth = document.getElementById('loadingBox-wscwebgl' + gameId).offsetWidth
					var length = ((canvasWidth / 8) * Math.min(progress, 1)).toString();
					var bar = document.getElementById('progressBar-wscwebgl' + gameId)
					//createjs.Tween.removeTweens(bar);
					//createjs.Tween.get(bar).to({width: length}, 10, createjs.Ease.sineOut);
					bar.style.width = length + 'px';
					var p = (progress * 100) | 0;
					//this.SetMessage('');
                    SetMessage('');
				}
            }
            else
            {
                if(progress == 0)
                {
				    //this.SetMessage('Initializing...');
                    SetMessage('Initializing...');
				} else if(progress > 0 && progress <= 1){
					var canvasWidth = document.getElementById('loadingBox-wscwebgl' + gameId).offsetWidth
					var length = ((canvasWidth / 8) * Math.min(progress, 1)).toString();
					var bar = document.getElementById('progressBar-wscwebgl' + gameId)
					//createjs.Tween.removeTweens(bar);
					//createjs.Tween.get(bar).to({width: length}, 10, createjs.Ease.sineOut);
					bar.style.width = length + 'px';
					var p = (progress * 100) | 0;
					//this.SetMessage('');
                    SetMessage('');
				}
            }
        }
        else
        {
            if(progress == 0)
            {
			    //this.SetMessage('Initializing...');
                SetMessage('Initializing...');
			} else if(progress > 0 && progress <= 1){
				var canvasWidth = document.getElementById('loadingBox-wscwebgl' + gameId).offsetWidth
				var length = ((canvasWidth / 8) * Math.min(progress, 1)).toString();
				var bar = document.getElementById('progressBar-wscwebgl' + gameId)
				//createjs.Tween.removeTweens(bar);
				//createjs.Tween.get(bar).to({width: length}, 10, createjs.Ease.sineOut);
				bar.style.width = length + 'px';
				var p = (progress * 100) | 0;
				//this.SetMessage('');
                SetMessage('');
			}
        }

        if (progress == 1){
		    var fullScreenButton = document.getElementById('fullScreenButton' + gameId);
		    if(fullScreenButton)
		    {
                if(mobileWebgl)
                {
                }
                else
                {
                    fullScreenButton.style.visibility = 'visible';
                }
		    }
		    var gameHeader = document.getElementById('game-header-wscwebgl' + gameId);
		    if(gameHeader)
		    {
		        gameHeader.style.display = 'none';
		    }
			//this.Clear();
            Clear();
		}
    }

    //var isLoadedUnityLoader = false;
    const isLoadedUnityLoader = useRef(false);
    const isInit = useRef(false);
    //const [loaded, setLoaded] = useState(false);
    var scriptTag = null;
    useEffect(() =>
    {
        //console.log('useEffect01 kint');
        //if(scriptTag == null)
        if(isInit.current == false)
        {
            isInit.current = true;
            SubscribeMouseLock();

            document.getElementById('autorun-wscwebgl' + gameId).style.display = 'inherit';
            //document.getElementById('autorun-wscwebgl' + gameId).style.display = 'none';
            document.getElementById('bgBar-wscwebgl' + gameId).style.display = 'none';
            document.getElementById('progressBar-wscwebgl' + gameId).style.display = 'none';
            document.getElementById('loadingInfo-wscwebgl' + gameId).style.display = 'none';
            coverLogo = document.getElementById('logoCover-wscwebgl' + gameId);
            if(coverLogo !== undefined && coverLogo.style !== undefined){
		        coverLogo.style.display = 'none';
		    }

            spinner = document.getElementById('spinner-wscwebgl' + gameId);
            if(spinner && spinner !== undefined && spinner.style !== undefined)
            {
	        	spinner.style.display = 'none';
            }

            //console.log('useEffect01 bent');
            scriptTag = document.createElement('script');
            scriptTag.src = loaderUrl;
            scriptTag.addEventListener('load', () =>
                {
                    //setLoaded(true);
                    
                    //console.log('scriptTag loaded');
                    //isLoadedUnityLoader = true;
                    isLoadedUnityLoader.current = true;
                    //document.getElementById('autorun-wscwebgl' + gameId).style.display = 'inherit';
                });
            //document.body.appendChild(scriptTag);
            var scriptParent = document.getElementById('script-parent');
            scriptParent.appendChild(scriptTag);

            if(autorun && !(isMobile && mobileWebgl== false))
            {
                if(mobileWebgl || document.exitPointerLock)
                {
                    window.addEventListener('load', function()
                {
                    OnPlayClick();
                    if(notExhibition == false)
                    {
                        sendGaEvent('send', 'event', {'eventCategory': 'VisitExhibition', 'eventAction': (embed) ? 'PlayWebGLEmbed' : 'PlayWebGL', 'eventLabel': exhibitionId + ' - ' + fixEventParam(exhibitionTitle)});
                    }
                });
                }
            }
        }
    }, []);

    //var isInit = false;
    //useEffect(() =>
    //{
    //    console.log('useEffect kint');
    //    if(isInit == false)
    //    {
    //        console.log('useEffect bent');
    //        //testFunct();
    //
    //        document.getElementById('autorun-wscwebgl' + gameId).style.display = 'inherit';
    //        document.getElementById('bgBar-wscwebgl' + gameId).style.display = 'none';
    //        document.getElementById('progressBar-wscwebgl' + gameId).style.display = 'none';
    //        document.getElementById('loadingInfo-wscwebgl' + gameId).style.display = 'none';
    //
    //        coverLogo = document.getElementById('logoCover-wscwebgl' + gameId);
    //        if(coverLogo !== undefined && coverLogo.style !== undefined){
	//	        coverLogo.style.display = 'none';
	//	    }
    //        
    //        spinner = document.getElementById('spinner-wscwebgl' + gameId);
    //        if(spinner && spinner !== undefined && spinner.style !== undefined)
    //        {
	//        	spinner.style.display = 'none';
    //        }
    //
    //        isInit = true;
    //    }
    //
    //}, [loaded]);

    const playWebGL = () =>
    {
        //console.log('playWebGL');
        
        if(mobileWebgl || document.exitPointerLock)
        {
            if((embed && notExhibition == false) && 
                (   exhibitionId == 'EV0M9HAKUDNY'
                    || exhibitionId == 'EVETFJ9Q5A2A'
                    || exhibitionId == 'EVZ7ROB8B7KS'
                    || exhibitionId == 'EVBB25CMM4QB'
                    || exhibitionId == 'EVQUG1RA0SJR'
                    || exhibitionId == 'EVEX5CSY7VO7'
                    || exhibitionId == 'EVHBO2BIAXUD'
                    || exhibitionId == 'EV6UGNPL87VV'
                ))
            {
                window.open(
                    'https://onlineviewingroom.com/exhibition/' + exhibitionId, 'blank'
                )
            }
            else
            {
                if(notExhibition == false)
                {
                    sendGaEvent('send', 'event', {'eventCategory': 'VisitExhibition', 'eventAction': (embed) ? 'PlayWebGLEmbed' : 'PlayWebGL', 'eventLabel': exhibitionId + ' - ' + fixEventParam(exhibitionTitle)});
                }
                OnPlayClick();
            }
        }
        else
        {
            //console.log('play kint');

            if(notExhibition == false)
            {
                sendGaEvent('send', 'event', {'eventCategory': 'VisitExhibition', 'eventAction': (embed) ? 'OpenAppEmbed' : 'OpenApp', 'eventLabel': exhibitionId + ' - ' + fixEventParam(exhibitionTitle)});
            }

            window.open(deepLink);
        }
    }
    
    //testFunct();

    return (
        <div>
        <div id='script-parent'></div>
        

        <div id={"template_" + gameId} className='unity-template-wscwebgl'>
            <div id={"canvas-wrap-wscwebgl"} className='canvas-wrap-wscwebgl' style={{paddingTop: aspectRatio + '%', backgroundColor: backgroundColor, border: gameBorder}}>
            <div id={"background-wscwebgl" + gameId} className='background-wscwebgl'>
                <img className='backgroundCoverImage' src={backgroundImg}/>
            </div>
            <div id={"loadingBox-wscwebgl" + gameId} className='loadingBox-wscwebgl'>
                <div id={'logoCover-wscwebgl' + gameId} className='logoCover-wscwebgl'>
                    <img width={50 + '%'} className='centerImage' src={wscCoverLogoImg}/>
                </div>
                <div id={"bgBar-wscwebgl" + gameId} className='bgBarWsc-wscwebgl'></div>
                <div id={"progressBar-wscwebgl" + gameId} className='progressBarWsc-wscwebgl'></div>
                <div><p id={"loadingInfo-wscwebgl" + gameId} className='loadingInfoWsc-wscwebgl'>Loading...</p></div>
                <div id={"spinner-wscwebgl" + gameId} className='spinnerWsc-wscwebgl'>
                    <img width={3 + '%'} className='centerImage' src={spinnerImg}/>
                </div>
                <div id={"autorun-wscwebgl" + gameId} className='autorunWsc-wscwebgl'>
                    {isMobile ?
                        <a href={deepLink} target='_blank' onClick={() => sendGaEvent('a', 'b', 'c')}>
                            <img className='backgroundCoverImage' src={[playAppImg]}/>
                        </a>
                    :
                        //<img className='backgroundCoverImage' src={[playImg]} onClick={() => mockPlay()} onMouseOver={() => setPlayImage(this, playHoverImg)} onMouseOut={() => setPlayImage(this, playImg)}/>
                        <img className='backgroundCoverImage' src={[playImg]} onClick={() => playWebGL()} onMouseOver={e => setPlayImage(e.currentTarget , playHoverImg)} onMouseOut={e => setPlayImage(e.currentTarget, playImg)}/>
                        //<img className='backgroundCoverImage' src={[playImg]} onClick={() => mockPlay()}/>
                    }
                </div>
            </div>
            
            {(embed && notExhibition == false && titleText != "") ?
            <div className='game-header-wscwebgl' id={"game-header-wscwebgl" + gameId}>
                <div className='game-header-text-wscwebgl' id='titleText'>
                    {titleText}
                </div>
            </div>
            :
                (editor && (editorDev || editorBeta) && titleText != "") ?
                    <div className='game-header-wscwebgl' id={"game-header-wscwebgl" + gameId}>
                        <div className='game-header-text-wscwebgl' id='titleText'>
                            {titleText}
                        </div>
                    </div>
                :
                ""
            }

            {(mobileWebgl) ?
            <div>
                <div className='mobileWebglScrollCoverLeft'></div>
                <div className='mobileWebglScrollCoverRight'></div>
            </div> : ""}
            
            <div className='game-footer-wscwebgl' id={"game-footer-wscwebgl" + gameId}>
                {(embed && notExhibition == false) ? 
                <a href={domain + '/exhibition/' + exhibitionId} target='_blank'><img className='game-footer-button-wscwebgl' src={(mobileWebgl) ? wscLogoImgSmall : wscLogoImg} title={openTitleText} /></a>
                :
                ""}
                <img className='game-footer-button-wscwebgl' id={"fullScreenButton" + gameId} style={{visibility: 'hidden', cursor: 'pointer', float:'right'}} src={fullScreenImg} alt='Fullscreen' title='Fullscreen' onClick={() => fullScreenClick(gameId)}/>
            </div>
            
            <div id={gameId} className='game-canvas-wscwebgl' style={{width:'100%', height:'100%', zIndex:'9'}}></div>

            </div>
        </div>
        </div>
        
    );
}